"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//

exports.default = {
  props: ["message"],

  created: function created() {
    var _this = this;

    if (this.message) {
      this.flash(this.message);
    }
    Event.listen("flash", function (data) {
      return _this.flash(data);
    });
  },


  methods: {
    flash: function flash(data) {
      switch (data.level) {
        case "success":
          this.$toastr.success(data.message);
          break;
        case "danger":
        case "error":
          this.$toastr.error(data.message);
          break;
        case "warning":
          this.$toastr.warning(data.message);
          break;
        case "info":
          this.$toastr.info(data.message);
          break;
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/notifiers/Flash.vue
// module id = DtNx
// module chunks = 0 1